import type { DeviceType } from '@provider-portal/common/styles/useThemeHooks';

import type { GlobalAppState } from 'rdx/state';
import type { ThemeState } from 'rdx/theme/reducer';

export function selectTheme(state: GlobalAppState): ThemeState {
  return state.theme;
}

export function selectDeviceType(state: GlobalAppState): DeviceType {
  return state.theme.deviceType;
}
